import type { FieldDescriptor } from './MasterDocument.types';

/**
 * Soporte declarativo de bloqueo de campos del MasterDocument (FEAT-104).
 *
 * A diferencia de `editableOn` (que decide si un campo es editable según el
 * estado), `lockedWhen` mantiene el campo visible y editable por estado pero lo
 * renderiza con un candado + tooltip cuando una condición de negocio impide
 * cambiarlo (p.ej. el documento ya tiene líneas).
 *
 * El bloqueo aplica cuando se cumplen TODAS las condiciones presentes en
 * `lockedWhen`. El estado `hasLines` lo deriva el kit (`lines.length > 0`); el
 * consumidor no lo inyecta.
 *
 * @see MasterDocument.types - FieldDescriptor.lockedWhen, FieldLockCondition
 */
export function isFieldLocked(
  field: Pick<FieldDescriptor, 'lockedWhen'>,
  docState: string,
  hasLines: boolean,
): boolean {
  const lock = field.lockedWhen;
  if (!lock) return false;
  const stateMatch =
    !lock.states || lock.states.length === 0 || lock.states.includes(docState);
  // `hasLines: true` → bloquea solo con líneas; `hasLines: false` → solo sin líneas.
  const linesMatch = lock.hasLines === undefined || lock.hasLines === hasLines;
  return stateMatch && linesMatch;
}
